module.exports = __webpack_public_path__ + "img/aplicacion-de-seguimiento.83516cab.png";